<template>
  <div class="observerIntersect"></div>
</template>

<script>
export default {
  name: "ObserverIntersect",
  data() {
    return {
      observer: null,
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit("intersect");
      }
    });

    this.observer.observe(this.$el);
  },
};
</script>

<style>
.observerIntersect {
  height: 10px;
}
</style>
